import interceptor from './interceptor';
import { Project } from 'data/projects';

const postToOpenAI = (project: Project) => {
  return interceptor.apiWithAuth
    .post('/OpenAI/post-to-openai', project)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error(error);
      return null;
    });
};

const openAIService = { postToOpenAI };
export default openAIService;
